import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import CardProfile from '../../../components/Profile/Card/';
import AddHolders from '../../../components/AddHolders';
import Snackbar from '../../../components/Snackbar';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import { Divider } from '@material-ui/core';
import { connect } from 'react-redux';
import HolderAdded from '../../../components/Profile/HolderAdded';
import TrophieModal from '../../../components/Modal/TrophieModal';
import { openModalFree } from '../../../store/actions/ModalFree';
import './addHolder.scss';

var Scroll = require('react-scroll');
var ElementScroll = Scroll.Element;

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginBottom: 16,
    marginTop: 24,
  },
  title: {
    fontSize: 22,
    color: '#013957',
    borderBottom: 'thin solid #e7e7e7',
    paddingBottom: 8,
    marginBottom: 23,
    width: '100%',
  },
  text: {
    color: '#484848',
    lineHeight: 'normal',
  },
  seeMore: {
    fontWeight: 'bold',
    color: '#10587f',
    lineHeight: 'normal',
    marginRight: 8,
  },
  expandButton: {
    color: '#013957',
    cursor: 'pointer',
    margin: '0 0 24px 0',
  },
  addSubtitle: {
    color: '#969696',
    margin: '0 0 0 24px',
    fontSize: 12,
  },
  summaryContent: {
    marginTop: 23,
    alignSelf: 'start',
  },
  divider: {
    border: '0.4px solid #e7e7e7',
    margin: '0 0 10px 0',
    width: '100%',
  }
}));

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    color: '#484848',
    borderRadius: 4,
    display: 'grid',
    '&::before': {
      height: 0,
    },
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    flexFlow: 'column',
    padding: 0,
    minHeight: 56,
    position: 'relative',
    backgroundColor: 'white',
  },
  content: {
    //margin: 0,
    width: '100%',
    flexFlow: 'column',
    alignItems: 'flex-start',
    cursor: 'auto',
    marginTop: 6,
    marginBottom: 8,
    //padding: 0,
    '&$expanded': {
      marginBottom: 16,
    },
  },
  expandIcon: {
    color: '#013957',
  },

  expanded: {
    //margin:0
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    padding:'16px 0 0',
    display: 'block',
    borderRadius: 4,
  },
})(MuiExpansionPanelDetails);

const AddHolder = props => {
  const { holders, authClient, membershipType, openModalFree } = props;

  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [alreadyRewarded, setAlreadyRewarded] = useState(false)
  const [openTrophieModal, setOpenTrophieModal] = useState(false);
  const [trophieValidation, setTrophieValidation] = useState(false)

  const handleTrophieModalClose = () => {
    setOpenTrophieModal(false);
  };

  const handleTrophieModalOpen = (trophie) => {
    setTrophieValidation(trophie)
    finishOpeningTrophieModal()
  };

  const finishOpeningTrophieModal = () => {
    if (alreadyRewarded === false) {
      setOpenTrophieModal(true);
      setAlreadyRewarded(true);
    }
  }
  
  const switchAlreadyRewarded = (bool) => {
    setAlreadyRewarded(bool)
  }
  
  const [nElem, setnElem] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    variant: 'success',
  });

  const handleChange = (event) => {
    // if (membershipType === 'Free') {
    //   openModalFree(true, membershipType, authClient.role)
    // } else {
    //   if (!expanded) {
    //     setExpanded(expanded ? false : true);
    //   }
    // }
    if (!expanded) {
      setExpanded(expanded ? false : true);
    }
  };

  const changeStatus = isActive => {
    setExpanded(isActive ? true : false);
  };

  const handleCloseFeedbackMessage = () => {
    setFeedbackMessage({
      open: false,
      message: '',
      variant: 'success',
    });
  };
  
  const handleSnackbar = () => {
    setFeedbackMessage({
      open: true,
      message: 'Tus cambios se han guardado con éxito',
      variant: 'success'
    });
  }

  let membershipLimit = 9

  useEffect(() => { 
   holders ? setnElem(holders.length) : setnElem(0);
  }, []);
 
  return (
    <>
      <ElementScroll name="myScroll_Holder">
        <div className="addHolder">
          <CardProfile
            title='Titular(es) del despacho'
            subTitle='Datos de contacto y experiencia del o los titulares.'
            awardIcon
            status={authClient && authClient.awardPerfil.holder ? authClient.awardPerfil.holder : false}
            style={{ padding: '24px 16px' }}
          >
            <ExpansionPanel
              expanded={expanded}
            >
              <ExpansionPanelSummary
                aria-controls="panel2a-content"
                style={{backgroundColor: 'white'}}
              >
                {holders && holders.length > membershipLimit ?
                  '' :
                  !holders || !holders.length ?
                  (
                    <div
                      className={classes.expandButton}
                      onClick={handleChange}
                      style={{ 
                        opacity: !expanded ? 'initial' : 0.5,
                        cursor: !expanded ? 'pointer' : 'not-allowed',
                      }}
                    >
                      <p id="t1">
                        <img className="plus" src="/img/profile/plus.svg" alt="" />
                        Agregar titular de despacho
                      </p>
                      {/* {membershipType === 'Free' ?
                        <div className={classes.addSubtitle}>
                          Disponible solo para usuarios Premium y Premium Plus
                        </div> : null
                      } */}
                    </div>
                  ) :
                  (
                    <div
                      className={classes.expandButton}
                      onClick={handleChange}
                      style={{ 
                        opacity: !expanded ? 'initial' : 0.5,
                        cursor: !expanded ? 'pointer' : 'not-allowed',
                      }}
                    >
                      <p id="t1">
                        <img className="plus" src="/img/profile/plus.svg" alt="" />
                        Agregar titular de despacho
                      </p>
                    </div>
                  )
                }

                {expanded === true || (holders && holders.length) >=1 ?
                  <Divider className={classes.divider} /> :
                  null
                } 

                {holders ? holders.map((item, index) => (
                    <HolderAdded
                      key={index}
                      elements={item}
                      nElem={index}
                      allHolders={holders}
                      handleSnack={handleSnackbar}
                      alreadyRewarded={alreadyRewarded}
                      handleRewarded={switchAlreadyRewarded}
                      handleTrophieModalOpen={handleTrophieModalOpen}
                    />
                  )) :
                  null
                }
              </ExpansionPanelSummary>

              <ExpansionPanelDetails>
                <AddHolders
                  handleSnack={handleSnackbar}
                  evento={changeStatus}
                  nElem={nElem}
                  allHolders={props.holders}
                  alreadyRewarded={alreadyRewarded}
                  handleRewarded={switchAlreadyRewarded}
                  handleTrophieModalOpen={handleTrophieModalOpen}
                />
              </ExpansionPanelDetails>
            </ExpansionPanel>
          </CardProfile>
        </div>
      </ElementScroll>

      <TrophieModal
        open={openTrophieModal}
        trophieValidation={trophieValidation}
        topic="award-profile"
        handleClose={handleTrophieModalClose}
        title='Titular(es) del despacho'
        subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
        footer='Agrega al titular o titulares del despacho, esto dará presencia al mismo.'
      />

      <Snackbar
        open={feedbackMessage.open}
        message={feedbackMessage.message}
        variant={feedbackMessage.variant}
        handleClose={handleCloseFeedbackMessage}
        vertical="top"
        horizontal="right"
        snackbarTop={isMobile ? '70px' : '80px'}
      />
    </>
  );
};

const mapStateToProps = state => ({
  membershipType: state.authClient.membership.type,
  holders: state.authClient.holders,
  authClient: state.authClient,
});

const mapDispatchToProps = dispatch => ({
  openModalFree: (open, membershipType, role) => dispatch(openModalFree(open, membershipType, role))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddHolder);
